import React from 'react'
import './JoinErrorPane.css'

export default function JoinErrorPane({errorData}) {

  const { 
    title, 
    note,
    blockers,
    supportOptions,
    userActions,
    ourActions,
    progressOptions,
  } = errorData;

  const hasAny = (someArray) => {
    return (someArray && someArray.length >0);
  }

  return (
    <div className='joinErrorPane'>
    {title            &&  <div className='joinErrorPaneTitle'>{title}</div>  }
    {note             &&  <div className='joinErrorPaneNote'>{note}</div>      }
    {hasAny(blockers) &&  <div className='errorPair'> 
                            <div className='joinErrorPaneHeader'>Explanation:</div>
                            {blockers.map((blocker, index) =>  <div className='joinErrorPaneData' key={index}> * {blocker} </div>)}
                          </div> }
    {hasAny(ourActions) &&  <div className='errorPair'>
                                <div className='joinErrorPaneHeader'>What we're doing about it:</div>
                                <div className='errorBox'>{
                                  ourActions.map( (ourAction, index) => <div className='joinErrorPaneData' key={index}>- {ourAction} </div>)
                                }</div>
                              </div> }

    {hasAny(userActions)  &&  <div className='errorPair'> 
                                <div className='joinErrorPaneHeader'>What can you do?</div>
                                <div className='errorBox'> {
                                userActions.map( (userAction, index) => <div className='joinErrorPaneData' key={index}>- {userAction}</div>)
                                } </div> 
                              </div> }

    {hasAny(supportOptions)  &&  <div className='errorPair'> 
                                <div className='joinErrorPaneHeader'>Support Options:</div>
                                <div className='errorBox'> {supportOptions.map( (supportOption , index) => <div className='joinErrorPaneData' key={index}> - {supportOption} </div>)} </div> 
                              </div> }
    {hasAny(progressOptions) &&  <div className='errorPair'>
                                <div className='joinErrorPaneHeader'>Issue Progress Tracking: </div>
                                <div className='errorBox'>
                                  {progressOptions.map( (progressOption, index) => <div className='joinErrorPaneData' key={index}> - {progressOption}</div>)}
                                </div>
                              </div>}      
    </div>
  )
}
